export default {
  SET_USER_INFO (state, user) {
    state.user = user
  },
  SET_WECHAT_USER (state, data) {
    state.wechatUser = data
  },
  SET_WECHAT_SHARE_INFO(state, shareInfo) {
    let {title, desc, imgUrl, columnName, articleType} = shareInfo
    title = title || state.shareInfo.title
    desc = desc || state.shareInfo.desc
    imgUrl = imgUrl || state.shareInfo.imgUrl
    columnName = columnName || state.shareInfo.columnName
    articleType = articleType || state.shareInfo.articleType
    state.shareInfo = Object.assign(state.shareInfo, {title, desc, imgUrl, columnName, articleType})
  },
  SET_WX_CONFIG_SUCCESS(state, isSuccess) {
    state.wxConfigSuccess = isSuccess
  },
  SET_IS_BIND_PHONE(state, hasBind) {
    state.wechatUser.hasBind = hasBind
  },
  SET_SERVICE_CONFIG(state, config) {
    state.serviceConfig = config
  }
}